<h2>Zeitslots</h2>
<div class="grid">
  <div class="col-12">
    <p-table [value]="timeslots" [rowTrackBy]="rowTrackBy" #table editMode="row" dataKey="id">
      <ng-template pTemplate="header">
        <tr>
          <th>#</th>
          <th>Datum</th>
          <th>Start</th>
          <th>Ende</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-timeslot let-index="rowIndex" let-editingRow="editing">
        <tr [pEditableRow]="timeslot">
          <td>{{index + 1}}</td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="output">
                <edu-udo-itmc-dev-mini-book-date-display [date]="timeslot.date"></edu-udo-itmc-dev-mini-book-date-display>
              </ng-template>
              <ng-template pTemplate="input">
                <input pInputText type="date" [ngModel]="timeslot.date|date:'yyyy-MM-dd'"
                  (ngModelChange)="change(timeslot, $event)" [ngModelOptions]="{updateOn: 'blur'}">
                </ng-template>
              </p-cellEditor>
              @if (checkTimeslot(timeslot)) {
                <div style="color: red">
                  <i class="pi pi-exclamation-circle"></i> Dieser Zeitslot liegt außerhalb des Veranstaltungszeitraums.
                </div>
              }
            </td>
            <td>
              <p-cellEditor>
                <ng-template pTemplate="output">
                  <edu-udo-itmc-dev-mini-book-time-display [time]="timeslot.start"></edu-udo-itmc-dev-mini-book-time-display>
                </ng-template>
                <ng-template pTemplate="input">
                  <input pInputText type="number" [(ngModel)]="timeslot.start.hours" max="24" min="0" style="width: 5em">:
                  <input pInputText type="number" [(ngModel)]="timeslot.start.minutes" max="60" min="0" style="width: 5em"> Uhr
                </ng-template>
              </p-cellEditor>
            </td>
            <td>
              <p-cellEditor>
                <ng-template pTemplate="output">
                  <edu-udo-itmc-dev-mini-book-time-display [time]="timeslot.end"></edu-udo-itmc-dev-mini-book-time-display>
                </ng-template>
                <ng-template pTemplate="input">
                  <input pInputText type="number" [(ngModel)]="timeslot.end.hours" max="24" min="0" style="width: 5em">:
                  <input pInputText type="number" [(ngModel)]="timeslot.end.minutes" max="60" min="0" style="width: 5em"> Uhr
                </ng-template>
              </p-cellEditor>
            </td>
            <td class="actionColumn">
              @if (editingRow) {
                <p-button icon="pi pi-save" pSaveEditableRow (click)="updateTimeslot(timeslot)" ariaLabel="Speichern"></p-button>
              }
              @if (editingRow) {
                <p-button icon="pi pi-times" pCancelEditableRow (click)="onTimeslotEditCancel(timeslot)" ariaLabel="Abbrechen"></p-button>
              }
              @if (!editingRow) {
                <p-button icon="pi pi-pencil" pInitEditableRow (click)="onTimeslotEditInit(timeslot)" [disabled]="editing" ariaLabel="Bearbeiten"></p-button>
              }
              @if (!editingRow) {
                <p-button icon="pi pi-trash" (click)="deleteTimeslot(timeslot)" [disabled]="editing" ariaLabel="Löschen"></p-button>
              }
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4">Bisher keine Timeslots vorhanden.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex gap-2 justify-content-end align-items-center p-3">
            <p-button label="Zeitslot hinzufügen" icon="pi pi-plus" (click)="createTimeslot(table)" [disabled]="editing" ariaLabel="Zeitslot hinzufügen"></p-button>
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
  <p-dialog header="Fehler beim Löschen des Zeitslots" [visible]="timeslotErrors != null" [closable]="false" [modal]="true">
    <edu-udo-itmc-dev-mini-book-error-renderer [errors]="timeslotErrors">
    </edu-udo-itmc-dev-mini-book-error-renderer>
    <ng-template pTemplate="footer">
      @if (timeslotInError) {
        <p-button icon="pi pi-check" (click)="clearTimeslotError(true)" label="Löschen erzwingen" styleClass="p-button-text" ariaLabel="Löschen erzwingen"></p-button>
      }
      <p-button (click)="clearTimeslotError(false)" label="Abbrechen" ariaLabel="Abbrechen"></p-button>
    </ng-template>
  </p-dialog>
